const { incognitoTest } = require('src/frontend/helper/incognito');

const GoogleMaps = require('../../helper/general/m_google_maps');

const loadAsyncJS = require('../../helper/general/m_loadAsyncJS');

const lazyLoadCss = require('../../helper/general/m_lazyLoadCss');

const makeTag = require('../../helper/general/m_makeTag');

const {
  detectCurrentLocation,
} = require('../../helper/search/helper/m_detectCurrentLocation');

const {
  externalObjectLoader,
  externalObjectLoaderOnready,
} = require('./externalObjectLoader');

const getConfigFromDom = require('../../helper/general/m_getConfigFromDom');

require('./groupon_extended');

const trackEvent = require('../../helper/general/m_trackEvent');

const unparam = require('../../helper/general/m_unparam');

// init Groupon object
if (window.Groupon == null) {
  window.Groupon = {};
}

Object.assign(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {
    isIncognito: incognitoTest('desktop'),
  },
});

// For desktop, LS has been init in the head.
// This is not the case for Touch.
const hasTouch =
  (typeof window.Modernizr !== 'undefined' &&
    window.Modernizr.touchevents.valueOf()) ||
  'ontouchstart' in window ||
  window.navigator.maxTouchPoints ||
  (window.DocumentTouch && document instanceof window.DocumentTouch);
const events = hasTouch ? 'touchstart' : 'click';

const pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400,
};

const mediaQueries = {
  xxlMin: `(min-width: ${pageWidths.xxl}px)`,
  xlMin: `(min-width: ${pageWidths.xl}px)`,
  slsLMin: `(min-width:  ${pageWidths.slsL}px)`,
  lMin: `(min-width:  ${pageWidths.l}px)`,
  mMin: `(min-width:  ${pageWidths.m}px)`,
  sMin: `(min-width:  ${pageWidths.s}px)`,
  xxlMax: `(max-width: ${pageWidths.xxl - 1}px)`,
  xlMax: `(max-width: ${pageWidths.xl - 1}px)`,
  slsLMax: `(max-width:  ${pageWidths.slsL - 1}px)`,
  lMax: `(max-width:  ${pageWidths.l - 1}px)`,
  mMax: `(max-width:  ${pageWidths.m - 1}px)`,
  sMax: `(max-width:  ${pageWidths.s - 1}px)`,
};

if (window.Groupon.LS == null) {
  window.Groupon.LS = {};
}
Object.assign(window.Groupon.LS, {
  hasTouch,
  events,
  mediaQueries,
  pageWidths,
  Header: {},
});

// For desktop, Modules has been init in the head.
// This is not the case for Touch.
if (window.Groupon.Modules == null) {
  window.Groupon.Modules = {};
}

if (window.Groupon.Utils == null) {
  window.Groupon.Utils = {};
}

Object.assign(Groupon.Utils, {
  unparam,
  makeTag,
  getConfigFromDom,
  externalObjectLoader,
  externalObjectLoaderOnready,
  GoogleMaps,
  trackEvent,
  loadAsyncJS,
  detectCurrentLocation,
  lazyLoadCss,
});
